import "./CoachMarkPopover.scss";

import React from "react";

import { ReactComponent as CloseGlyph } from "../assets/close.svg";
import tada from "../assets/tada.png";
import coachMarkContents, {
  coachMarkCelebrationToken,
} from "../coachMarks/coachMarkContents";
import { SimpleCoachMarkID } from "../coachMarks/coachMarkListing";
import IconButton from "./IconButton";
import Markdown from "./Markdown";
import Popover from "./Popover";
import { SpacedRepetitionSchedule } from "../spacedRepetition";

interface Props {
  referenceElement: HTMLElement;
  interiorRef?: React.Ref<HTMLDivElement>;
  placement?: "top" | "left" | "bottom" | "right";
  onCloseAction: () => void;
  coachMarkID: SimpleCoachMarkID;
  schedule: SpacedRepetitionSchedule;
}

export default function CoachMarkPopover(props: Props) {
  const {
    referenceElement,
    interiorRef,
    placement,
    onCloseAction,
    coachMarkID,
    schedule,
  } = props;

  let text = coachMarkContents[coachMarkID]({ schedule });
  let isCelebration = false;
  if (text.startsWith(coachMarkCelebrationToken)) {
    text = text.slice(coachMarkCelebrationToken.length);
    isCelebration = true;
  }

  return (
    <Popover
      interiorRef={interiorRef}
      placement={placement}
      referenceElement={referenceElement}
      className={`CoachMarkPopover ${isCelebration ? "Celebration" : ""}`}
    >
      <IconButton className="CloseButton" onClick={onCloseAction}>
        <CloseGlyph />
      </IconButton>
      {isCelebration && <img src={tada} alt="" className="CelebrationGlyph" />}
      <div className="Body">
        <Markdown>{text}</Markdown>
      </div>
    </Popover>
  );
}
